module.exports = __webpack_public_path__ + "img/header-unsel-home.8b296828.svg";